import React, { useEffect, useState } from "react";
import "./banner.scss";
import Registermodal from "../modals/Registermodal";
import Joinmodal from "../modals/Joinmodal";

const Banner = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
  }, []);

  const [modals, setModals] = useState({
    join: false,
    register: false,
  });

  const closeModal = (name) =>
    setModals((prev) => ({ ...prev, [name]: false }));
  return (
    <>
      <section className="mainbanner">
        <img
          src={
            isMobile
              ? "/assets/banner/bannershadembl.png"
              : "/assets/banner/bannershade.png"
          }
          alt="img"
          className="bannershade"
        />
        <img
          src={isMobile ? "" : "/assets/banner/layer.png"}
          alt="img"
          className={isMobile ? "d-none" : "layerbg"}
        />
        <video
          className="main-banner-video"
          muted="muted"
          playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="/assets/banner/bannervideo.mp4.mov" type="video/mp4" />
        </video>
        <div className="custom-container">
          <div className="maincontent">
            <button className="market">Verified Market Transparency</button>
            <h2 className="head">Market Transparency Platform</h2>
            <p className="para">
              TraqStock brings verified share structure data, trading
              intelligence, and identity-verified investor discussions together
              in one transparent platform for public companies and investors.
            </p>
            <div className="mainbutton">
              <button onClick={()=>{
                window.location.href = "https://app.traqstock.com";
              }} className="join">Join as Investor</button>
              <button onClick={()=>{
                window.location.href = "https://agent.traqstock.com";
              }} className="public">Join as Company Agent</button>
            </div>
          </div>
        </div>
        <img
          src="/assets/banner/bannerlowerimg.png"
          alt="bannerlowerimg"
          className="bannerlowerimg"
        />
      </section>
      <div className="bannerspacer"></div>

      <Joinmodal show={modals.join} onHide={() => closeModal("join")} />
      <Registermodal show={modals.register} onHide={() => closeModal("register")} />
    </>
  );
};

export default Banner;
